import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import { H1 } from 'styled-system';

import styles from './ContentBoxTitle.module.scss';

type ContentBoxTitleProps = {
    title: ReactNode;
    align?: 'left' | 'center' | 'right';
    compact?: boolean;
    className?: string;
};

const ContentBoxTitle = ({
    title,
    align = 'center',
    compact,
    className
}: ContentBoxTitleProps): ReactElement => {
    return (
        <H1
            compact
            color="base"
            className={classnames(styles.heading, className, styles[align], {
                [styles.compact]: compact
            })}
        >
            {title}
        </H1>
    );
};

export default ContentBoxTitle;
